import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { resetUser } from "../../../state/actions/UserActions";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { SxProps } from "@mui/system";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import blackWallet from "../../../assets/images/black-wallet.png";
import greenDot from "../../../assets/images/green-dot.png";
import grayDot from "../../../assets/images/grey-dot.png";
import UserFund from "../../../entities/UserFund";
import { setActiveFund } from "../../../state/actions/DashboardActions";
import { LogOut } from "../../../services/LogOut";
import { isEnterPress } from "../../../utils/helpers/accessibilityUtil";
import {
  setModalChild,
  setModalState,
} from "../../../state/actions/modalAction";
import DisconnectPopUp from "../../DisconnectPopUp/DisconnectPopUp";
import "../../../assets/scss/variables.scss";
import "./HeaderDropdown.scss";
import { PENSION_FUND_LABEL_AR } from "../../../utils/constants/PensionConsts";

const HeaderDropdown = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation("common");
  const { firstName, lastName, userFunds, pensionTypeDescHeader } = useSelector(
    (state: any) => state.UserReducer
  );
  const { setFundCount } = useSelector(
    (state: any) => state.DashboardReducer
  );
  const [open, setOpen] = useState(false);

  const logOutPopUpHandler = () => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <DisconnectPopUp callbackDisconnect={logout} center={true} size="m" />
      )
    );
  };

  const logout = () => {
    dispatch(setModalState(false));
    dispatch(resetUser());
    dispatch(setActiveFund({} as UserFund));
    const refreshTokenNum = sessionStorage.getItem("refreshTokenNum");
    if (!refreshTokenNum) return;
    LogOut(refreshTokenNum);
    if(history != null) 
      history.push("/login");      
  };

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const getFundIcon = (fund: UserFund) => {
    if (fund.isPensioner) {
      return blackWallet;
    } else {
      if (fund.isActiveFund) {
        return greenDot;
      }
      return grayDot;
    }
  };

  const handleFundClick = (fund: UserFund) => {
    dispatch(setActiveFund(fund));
    if (location.pathname !== "/") {
      history.push("/");
    }
  };

  const fundDesc = (fund: UserFund) =>{
   return fund.isPensioner ?
   pensionTypeDescHeader && 
   setFundCount == 2 ? pensionTypeDescHeader[fund.fundCode].slice(0, 19) + "..."  : pensionTypeDescHeader[fund.fundCode]     
     : `${t("Dashboard.pensionFund")}`      
  }
  
  const styles: SxProps = {
    // position: "absolute",
    top: 52,
    width: "-webkit-fill-available",
    left: 16,
    zIndex: 1,
    bgcolor: "#ffffff",
    borderRadius: "0 0 25px 25px",
  };

  return (
    <>
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        sx={{ position: "relative" }}
        onClick={handleClick}
        onKeyPress={(event) => isEnterPress(event) && handleClick()}
        tabIndex={0}
        aria-expanded={open?"true":"false"} 
        role="button"
      >
        <div
          className="details-btn"
          style={{
            borderBottom: `${open ? "1px solid whitesmoke" : ""}`,
            borderRadius: `${open ? 0 : ""}`,
          }}
          
        >
          <span>{`${t("Sidebar.hello")} ${firstName} ${lastName}`}</span>
          {!open && <KeyboardArrowDownIcon fontSize="small" />}
        </div>
      </Box>
    </ClickAwayListener>
        {open ? (
          <Box sx={styles}>
            {userFunds?.length &&
              userFunds.map((fund: UserFund, index: number) => (
                <div
                  className={`header-dropdown-item ${
                    fund.isAmit && "pa-for-bigger-icons-header-dropdown"
                  }`}
                  key={index}
                  onClick={() => handleFundClick(fund)}
                  onKeyPress={(event) =>
                    isEnterPress(event) ? handleFundClick(fund) : null
                  }
                  tabIndex={0}
                  role="link"
                >                 
                   <img src={getFundIcon(fund)} width={27} height={27} alt="" role="presentation" aria-hidden="true" /> 
                  <div
                    className="header-dropdown-labels-wrapper"
                    style={{ marginRight: `${fund.isAmit ? "5px" : ""}` }}
                  >
                    {localStorage.getItem('lang') === "he"?<span>{fund.fundLabel}</span>:<span>{fund.fundNameArab}</span>}
                    <span>{fundDesc(fund)}</span>
                  </div>
                </div>
              ))}
            <div
              className="header-dropdown-item"
              onClick={logOutPopUpHandler}
              onKeyPress={(event) =>
                isEnterPress(event) ? logOutPopUpHandler() : null
              }
              tabIndex={0}
              role="button"
            >
              <LogoutOutlinedIcon fontSize="small" role="presentation" aria-hidden="true" />
              <div className="header-dropdown-labels-wrapper">
                <span>{t("general.logOut")}</span>
              </div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center cursor-pointer"
              tabIndex={0}
              role="button"
              aria-label={t("arialabel.closeMenu")}
            >
              <KeyboardArrowUpIcon fontSize="small" />
            </div>
          </Box>
        ) : null}
    </>
  );
};

export default HeaderDropdown;
